import { message } from 'antd';
import { getFileTypeBySuffix } from '@/utils';
import { fileTypeMap } from '@/utils/Page/constant';
const messageError = (msg) => {
    message.error(msg);
};
// 封装图片加载为Promise
const loadImage = (file) => {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = () => {
            // 加载成功，释放URL对象并返回图片信息
            URL.revokeObjectURL(image.src);
            resolve({ width: image.width, height: image.height });
        };
        image.onerror = () => {
            // 加载失败处理
            URL.revokeObjectURL(image.src);
            reject(new Error(`${file.name}图片加载失败`));
        };
        // 开始加载图片
        image.src = URL.createObjectURL(file);
    });
};
//校验图片像素
// 宽 > 14 且 高>14。宽*高范围： [196, 3600万]。宽高比不应超过200:1或1:200
export const verifyPx = async (file) => {
    const { width, height } = await loadImage(file);

    if (width < 14 || height < 14) {
        messageError(`${file.name}图片宽高必须大于等于14。`);
        return false;
    }
    if (width * height < 196 || width * height > 3600 * 10000) {
        messageError(`${file.name}图片宽*高范围必须在196*196到3600万之间。`);
        return false;
    }
    if (width / height > 200 || height / width > 200) {
        messageError(`${file.name}图片像素宽高比不应超过200:1或1:200。`);
        return false;
    }
    return true;
};
// 验证文件大小
export const verifyFileSize = async (file, fileExt) => {
    let fileType = getFileTypeBySuffix(fileExt);

    let maxSize = 15 * 1024 * 1024;
    if (fileType === fileTypeMap.img) {
        maxSize = 10 * 1024 * 1024;
        let pxtest = await verifyPx(file);
        if (!pxtest) {
            return false;
        }
    }
    if (file.size > maxSize) {
        messageError(`${file.name}不符合大小限制，只支持15M以内的文件以及10M以内的图片。`);
        return false;
    }
    return true;
};
// 验证文件类型
export const verifyFileType = (file, accept, fileExt) => {
    if (!accept.includes(fileExt.toLowerCase())) {
        messageError(`${file.name}文件类型不支持，已过滤上传的文件。`);
        return false;
    }
    return true;
};

//验证文件
export const verifyFile = async (file, acceptTypeArr, fileExt) => {
    if (!file) {
        return false;
    }

    //校验文件类型
    let typeRes = verifyFileType(file, acceptTypeArr, fileExt);

    if (!typeRes) {
        return false;
    }
    //校验文件大小
    let sizeRes = await verifyFileSize(file, fileExt);

    if (!sizeRes) {
        return false;
    }
    return true;
};
